
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/8805101016298200d7dde23f34186502.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Fast, Flexible Funding for
            <span className="text-blue-400 block">Real Estate Investors</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            We're your trusted commercial real estate brokerage firm connecting investors and businesses with tailored lending solutions through our extensive network of lenders.
          </p>
          
          {/* Credit Building CTA */}
          <div className="mb-8 p-4 bg-blue-600/20 backdrop-blur-sm rounded-lg border border-blue-400/30">
            <p className="text-lg text-blue-100 mb-3">
              Want to build your business credit to access endless amounts of capital or build your personal credit?
            </p>
            <a 
              href="https://fastfundingcap.net" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-external-link-line"></i>
              </div>
              Click Here
            </a>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg"
              onClick={() => scrollToSection('pre-approval')}
              className="bg-blue-600 hover:bg-blue-700"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-rocket-line"></i>
              </div>
              Get Pre-Approved Now
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => scrollToSection('services')}
              className="border-white text-white hover:bg-white hover:text-blue-600"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-list-check-line"></i>
              </div>
              View Loan Products
            </Button>
          </div>
          
          {/* Key Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Fast Process</h3>
              <p className="text-gray-200">No hard inquiry during pre-approval. Get results quickly.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Transparent Process</h3>
              <p className="text-gray-200">Compliance-first approach with no misleading guarantees.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Expert Advisory</h3>
              <p className="text-gray-200">We position your business for maximum funding approvals.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
